module.exports = __webpack_public_path__ + "img/Group 97803.194ffa45.png";